export class EnvironmentUtils {
  public static isMobile(): boolean {
    return window.matchMedia("(max-width: 960px)").matches;
  }

  public static isLocalEnv(): boolean {
    return process.env.VUE_APP_ENV === "local";
  }
}
